import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      // Wider than sonner's 356px default: these messages are sentences, not one-liners.
      // Capped to the screen, or an inline 420px beats sonner's own phone layout
      // and the toast runs off a 360px phone.
      style={{ width: 'min(420px, calc(100vw - 2rem))' }}
      // Below the notch / status bar once the app draws edge-to-edge.
      mobileOffset={{ top: 'calc(env(safe-area-inset-top, 0px) + 0.75rem)', left: '1rem', right: '1rem' }}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:text-sm group-[.toaster]:leading-relaxed",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
